import R from 'ramda'

export const ascByName = R.ascend(
  R.compose(
    R.toLower,
    R.prop('name')
  )
)
export const descByName = R.descend(
  R.compose(
    R.toLower,
    R.prop('name')
  )
)
